import {
  isSystemUnassignedDoctorName,
  UNASSIGNED_DOCTOR_SELECT_VALUE,
  UNASSIGNED_DOCTOR_SORT_PREFIX,
} from "./appointmentDoctorSelect";

export const UNASSIGNED_DOCTOR_RESOURCE_ID = -1;
/** 虛擬隨機欄顯示名。不是某一位員工的姓名。 */
export const UNASSIGNED_DOCTOR_RESOURCE_LABEL = "不指定醫師";
export const UNASSIGNED_DOCTOR_DETAIL_LABEL = "不指定醫師";

export function hasConcreteAppointmentDoctorId(employeeId) {
  if (
    employeeId == null ||
    employeeId === "" ||
    employeeId === UNASSIGNED_DOCTOR_SELECT_VALUE
  ) {
    return false;
  }
  const n = Number(employeeId);
  return (
    Number.isFinite(n) &&
    n !== 0 &&
    n !== UNASSIGNED_DOCTOR_RESOURCE_ID
  );
}

/**
 * 有具體服務醫師 id → 一律歸該醫師欄（即使 is_unassigned）。
 * 沒有醫師 id 且為隨機時，歸虛擬欄 -1，不掛到姓名叫「不指定醫師」的員工。
 */
export function resolveAppointmentDoctorGroupId(appointment, _employees = []) {
  const employeeId = appointment?.employee_id ?? appointment?.employeeId;
  if (hasConcreteAppointmentDoctorId(employeeId)) {
    return employeeId;
  }
  if (appointment?.is_unassigned === true) {
    return UNASSIGNED_DOCTOR_RESOURCE_ID;
  }
  return employeeId ?? null;
}

/** 不再為「沒有系統不指定醫師」補虛擬欄；欄位只來自真實團隊成員 */
export function shouldUseVirtualUnassignedDoctorColumn(_employees = []) {
  return false;
}

export function hasUnassignedAppointments(appointments = [], employees = []) {
  if (!shouldUseVirtualUnassignedDoctorColumn(employees)) return false;
  return (appointments || []).some(
    (appointment) =>
      resolveAppointmentDoctorGroupId(appointment, employees) ===
      UNASSIGNED_DOCTOR_RESOURCE_ID
  );
}

export { isSystemUnassignedDoctorName };

export function buildUnassignedDoctorResource(generateAvatarSvg) {
  const displayName = UNASSIGNED_DOCTOR_RESOURCE_LABEL;
  const sortLabel = `${UNASSIGNED_DOCTOR_SORT_PREFIX}${displayName}`;
  return {
    id: UNASSIGNED_DOCTOR_RESOURCE_ID,
    value: UNASSIGNED_DOCTOR_RESOURCE_ID,
    label: sortLabel,
    text: sortLabel,
    name: sortLabel,
    doctorName: displayName,
    is_archived: false,
    speciality: "現場補單",
    image: generateAvatarSvg ? generateAvatarSvg(displayName) : "",
    backgroundColor: "#9AA5B1",
  };
}

/** 表單「指定人員」：0 指定 / 1 不指定 */
export function resolveFormIsUnassignedValue(appointment) {
  return appointment?.is_unassigned === true ? 1 : 0;
}

export function isFormUnassignedSelected(value) {
  return value === true || value === 1 || value === "1";
}

/**
 * 明細／預覽「服務醫師」：顯示實際醫師名
 */
export function resolveAppointmentDoctorDisplayName(
  appointment,
  employeesLookup = {}
) {
  const employeeId = appointment?.employee_id;
  return (
    appointment?.employee_name ||
    employeesLookup?.[employeeId]?.name ||
    employeesLookup?.[Number(employeeId)]?.name ||
    ""
  );
}

/**
 * 編輯表單醫師欄：有具體服務醫師就帶該 id。
 * 沒有 id 且為隨機時，改選下拉的「不指定醫師」，不選姓名相同的員工。
 */
export function resolveFormEmployeeSelectValue(appointment, _employees = []) {
  const id = appointment?.employee_id ?? appointment?.employeeId;
  if (!hasConcreteAppointmentDoctorId(id)) {
    if (appointment?.is_unassigned === true) {
      return UNASSIGNED_DOCTOR_SELECT_VALUE;
    }
    return null;
  }
  return id;
}
